// extracted by mini-css-extract-plugin
module.exports = {"iconBox":"styles_iconBox__3mN2k","stakeModalBody":"styles_stakeModalBody__gov_L"};